// @flow

import React from 'react';
import styled from 'styled-components';
import { Badge } from 'primitive-components';

const AvatarCircle = styled.div`
  align-items: center;
  background-color: ${({ backgroundColor }) => backgroundColor};
  border-radius: 50%;
  border: none;
  color: ${({ textColor }) => textColor};
  display: flex;
  flex: 0 0 auto;
  font-size: ${({ fontSize }) => fontSize};
  font-weight: ${({ fontWeight }) => fontWeight};
  height: ${({ size }) => size};
  justify-content: center;
  position: relative;
  width: ${({ size }) => size};

  &:focus {
    outline: 0;
  }

  ${Badge} {
    position: absolute;
    top: -2px;
    right: -2px;
  }
`;

type AvatarProps = {
  name: string,
  notificationCount: number,
  size: string,
  backgroundColor: string,
  textColor: string,
  fontWeight: string,
  fontSize: string,
};

const Avatar = ({
  name,
  notificationCount,
  size,
  backgroundColor,
  textColor,
  fontSize,
  fontWeight,
}: AvatarProps) => (
  <AvatarCircle
    fontWeight={fontWeight}
    fontSize={fontSize}
    size={size}
    backgroundColor={backgroundColor}
    textColor={textColor}
  >
    {name.substr(0, 1)}
    {notificationCount > 0 && <Badge>{notificationCount}</Badge>}
  </AvatarCircle>
);

export default Avatar;
